const fileConfig = () => {
	const config = "laravel";
	return config;
};

export default fileConfig;
